<!-- Footer -->
<!-- Container -->
<div class="kt-container-fixed">
	<div class="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
		<div class="flex order-2 md:order-1 gap-2 font-normal text-sm">
			<span class="text-muted-foreground">
				2025©
			</span>
			<a class="text-secondary-foreground hover:text-primary" href="https://keenthemes.com">
				Keenthemes Inc.
			</a>
		</div>
		<nav class="flex order-1 md:order-2 gap-4 font-normal text-sm text-secondary-foreground">
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs">
				Docs
			</a>
			<a class="hover:text-primary" href="https://1.envato.market/Vm7VRE">
				Purchase
			</a>
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license">
				FAQ
			</a>
			<a class="hover:text-primary" href="https://devs.keenthemes.com">
				Support
			</a>
			<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license">
				License
			</a>
		</nav>
	</div>
</div>
<!-- End of Container -->
<!-- End of Footer -->